import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters, mapMutations } from 'vuex'
// import * as types from '@mail/store/types'
import orgmapStorage from '@orgmap/util/storage-helper'
import EumTagInput from 'eum-tag-input-mobile'
import * as dateutil from '@/util/date-helper'
import $ from 'jquery'
import DisplayName from '@/components/common/DisplayName.vue'
import * as orgTypes from '@orgmap/store/types'
import * as accountTypes from '@account/store/types'
import OrgchartModal from './Modal/OrgchartModal.vue'
import orgmapApi from '@orgmap/api'

@Component({
  components: { DisplayName, EumTagInput, OrgchartModal},
  computed: mapGetters({
    User: accountTypes.USER,
    userList: orgTypes.ORG_USER_SELECT,
  })
})
export default class RecipientFields extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //
  @Prop({ type: Array }) value!: mail.RecipientTag[]
  @Prop({ type: String }) title!: String
  @Prop({ type: Object }) email!: mail.WriteEmailData
  @Prop({ type: String }) type!: ''

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  get rcpts() {
    return this.value || []
  }

  set rcpts(value) {
    this.$emit('input', value)
    this.$emit('change')
  }

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //
  showorg: boolean = false
  open: boolean = false
  isShow: boolean = false
  showAutoComplete: boolean = false
  autoCompleteList: any = []
  showMove: boolean = false

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  userList!: orgmap.TUser[]
  User!: account.User

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  error(e: Event) {
    var elem = e.srcElement as HTMLImageElement
    elem.src = '/cm/gres/faux/images/ghost.png'
  }

  changeAutoComplete() {
    this.showAutoComplete = false
    this.autoCompleteList = []
    ;(this.$refs.eumInput as any).showAutoComplete = false
    ;(this.$refs.eumInput as any).ignoreBlur = false
    ;(this.$refs.eumInput as any).ignoreEnter = false
  }

  searchAction(uniqueId: string) {
    let valueKey = `value_${uniqueId}`
    let value = (window as any)[valueKey]
    orgmapApi.hr
      .searchOrg(
        {
          query: value,
          size: 10,
        },
        this.User.comCode
      )
      .then((res: any) => {
        this.openAutoComplete({
          text: 'displayName',
          value: 'email',
          deptName: 'deptName',
          titleName: 'titleName',
          img: 'photoPath',
          imgRoot: '/cm/gres/v1/img/user',
          type: 'type',
          data: res.items,
          comCode: 'comCode',
          deptCode: 'deptCode',
          companyName: 'companyName'
        })
        clearInterval((window as any)[uniqueId])
        ;(window as any)[uniqueId] = null
      })
      .catch((err: any) => {
        clearInterval((window as any)[uniqueId])
        ;(window as any)[uniqueId] = null
      })
  }

  openAutoComplete(options: any) {
    ;(this.$refs.eumInput as any).clearAllAutoComplete()
    ;(this.$refs.eumInput as any).autoCompleteClearFlag = false
    let text = options.displayName || 'displayName'
    let value = options.email || 'email'
    let deptName = options.deptName || 'deptName'
    let type = options.type || 'type'
    let titleName = options.titleName || 'titleName'
    let img = options.photoPath || 'photoPath'
    let imgRoot = options.imgRoot || ''
    let errorImg = options.errorImg || '/cm/gres/faux/images/ghost.png'
    let count = options.count || 10
    let data = options.data || []
    let deptCode = options.deptCode || 'deptCode'
    let comCode = options.comCode || 'comCode'
    let companyName = options.companyName || 'companyName'
    this.autoCompleteList = data
      .splice(0, count)
      .map((x: any) => {
        let obj = {
          text: '',
          value: '',
          deptName: '',
          titleName: '',
          img: '',
          type: '',
          imgRoot: imgRoot,
          errorImg: errorImg,
          deptCode: '',
          comCode: '',
          companyName: '',
        }

        if (x.hasOwnProperty(text)) {
          obj.text = x[text]
        }

        if (x.hasOwnProperty(value)) {
          obj.value = x[value]
        }

        if (x.hasOwnProperty(deptName)) {
          obj.deptName = x[deptName]
        }

        if (x.hasOwnProperty(type)) {
          obj.type = x[type]
        }

        if (x.hasOwnProperty(titleName)) {
          obj.titleName = x[titleName]
        }

        if (x.hasOwnProperty(img)) {
          obj.img = x[img]
        }

        if (x.hasOwnProperty(deptCode)) {
          obj.deptCode = x[deptCode]
        }

        if (x.hasOwnProperty(comCode)) {
          obj.comCode = x[comCode]
        }

        if (x.hasOwnProperty(companyName)) {
          obj.companyName = x[companyName]
        }

        return obj
      })
      .filter(
        (x: any) =>
          (this.$refs.eumInput as any).tags.filter((y: any) => y.value == x.value).length == 0
      )

    this.showAutoComplete = this.autoCompleteList.length

    if (this.showAutoComplete) {
      ;(this.$refs.eumInput as any).showAutoComplete = true
      ;(this.$refs.eumInput as any).ignoreBlur = true
      ;(this.$refs.eumInput as any).ignoreEnter = true
    }
  }

  inputKeyDown(e: Event) {
    let target = e.target as HTMLInputElement
    let value = target.value
    const delayTime = 300
    if (value) {
      let uniqueId = `pos_${target.offsetTop}_${target.offsetLeft}`
      let timeKey = `idx_${uniqueId}`
      let valueKey = `value_${uniqueId}`
      let flagKey = `flag_${uniqueId}`
      ;(window as any)[flagKey] = false
      ;(window as any)[valueKey] = value
      if (!(window as any)[uniqueId]) {
        ;(window as any)[timeKey] = dateutil.uGetDate(delayTime, new Date(), 'time')
        ;(window as any)[uniqueId] = setInterval(() => {
          if ((window as any)[timeKey] < new Date()) {
            if (!(window as any)[flagKey]) {
              ;(window as any)[flagKey] = true
              this.searchAction(uniqueId)
            }
          }
        }, 11)
      } else {
        ;(window as any)[timeKey] = dateutil.uGetDate(delayTime, new Date(), 'time')
      }
    } else {
      this.showAutoComplete = false
      ;(this.$refs.eumInput as any).showAutoComplete = false
      ;(this.$refs.eumInput as any).ignoreBlur = false
      ;(this.$refs.eumInput as any).ignoreEnter = false
    }
  }

  autoCompleteSelect(user: any) {
    ;(this.$refs.eumInput as any).text = user.text
    ;(this.$refs.eumInput as any).ignoreEnter = true
    ;(this.$refs.eumInput as any).ignoreBlur = true
    ;(this.$refs.eumInput as any).appendByKey(true, {
      text: user.text,
      value: user.value,
      deptCode: user.deptCode,
      deptName: user.displayDeptName,
      personCode: user.personCode,
      comCode: user.comCode,
    })
    this.showAutoComplete = false
    ;(this.$refs.eumInput as any).showAutoComplete = false
    ;(this.$refs.eumInput as any).ignoreBlur = false
    ;(this.$refs.eumInput as any).ignoreEnter = false
  }

  setInputFocus(e: Event) {
    let elem = e.target as HTMLElement
    let $input = $(elem).find('.eum-tag-inputbox')
    if ($input.length) {
      $input.focus()
    }
  }

  tagAdded(tag: any) {
    let userInfo: any
    if (this.value.length) {
      let tempUser: any = this.value.map((v: any) => {
        return {
          name: v.text,
          email: v.value,
          deptCode: v.deptCode,
          comCode: v.comCode,
          deptName: v.displayDeptName,
          personCode: v.personCode,
        }
      })

      userInfo = {
        type: this.type,
        users: tempUser,
      }

      userInfo.users.push({
        name: tag.text,
        email: tag.value,
        deptCode: tag.deptCode,
        comCode: tag.comCode,
        deptName: tag.displayDeptName,
        personCode: tag.personCode,
      })
    } else {
      userInfo = {
        type: this.type,
        users: [
          {
            name: tag.text,
            email: tag.value,
            deptCode: tag.deptCode,
            comCode: tag.comCode,
            deptName: tag.displayDeptName,
            personCode: tag.personCode,
          },
        ],
      }
    }

    this.updateRecipients(userInfo)
    orgmapStorage.set(userInfo)
  }

  tagDeleted(tag: any) {
    let userInfo: any

    if (this.value.length) {
      let tempUser: any = this.value.map((v: any) => {
        return { name: v.text, email: v.value }
      })

      userInfo = {
        type: this.type,
        users: tempUser,
      }

      let idx = this.value.indexOf(tag)
      userInfo.users.splice(idx, 1)
    }

    this.updateRecipients(userInfo)
    orgmapStorage.set(userInfo)
  }

  updateRecipients(list: any) {
    const email = this.email
    let userList: any
    if (list.users) {
      userList = list.users.map((userInfo: any) => {
        return {
          name: userInfo.name,
          email: userInfo.email,
          deptCode: userInfo.deptCode,
          comCode: userInfo.comCode,
          deptName: userInfo.displayDeptName,
          personCode: userInfo.personCode,
        }
      })
    }
    const visibles: mail.state.MailWriteVisibles = Object.create(null)
    const set = function(users: OrgPersons, type: string) {
      if (users && users.length > 0) {
        const list: any[] = ((email as any)[type] = [])
        users.forEach((user) => {
          list.push({
            text: user.name,
            value: user.email,
            comCode: user.comCode,
            deptCode: user.deptCode,
            deptName: user.displayDeptName,
            personCode: user.personCode,
          })
        })
        ;(visibles as any)[type] = true
      }
    }

    set(userList, this.type)
  }

  //  조직도 팝업
  openOrgchart() {
    let list = (this.email as any)[this.type] || []

    list = list.map((x: any) => {
      return {
        name: x.name || (x as any).text,
        email: x.address || (x as any).value,
        deptCode: x.deptCode,
        comCode: x.comCode,
      }
    })
    orgmapStorage.set(list)
    this.showMove = true
  }

  show() {
    this.open = !this.open
    this.$emit('showWriteCC', this.open)
  }

  async check() {
    const type = this.type

    let userInfo = {
      type: type,
      users: this.userList.map((user: orgmap.TUser) => ({
        email: user.email,
        name: user.displayName,
        deptCode: user.deptCode,
        comCode: user.comCode,
        deptName: user.displayDeptName,
        personCode: user.personCode,
      })),
    }

    const excepts = this.userList.filter((u: orgmap.TUser) => !u.email)
    if (excepts.length > 0) {
      await(window as any).alertAsync(
        '메일 주소가 없는 사용자는 제외합니다. ' +
          excepts.map((u: any) => u.displayName || u.name || u.deptName).join(',')
      )
    }
    let userList = this.userList
      .filter((u: orgmap.TUser) => u.email)
      .map((user: orgmap.TUser) => ({
        email: user.email,
        name: user.displayName,
        deptCode: user.deptCode,
        comCode: user.comCode,
        deptName: user.displayDeptName,
        personCode: user.personCode,
      })) as any
    const email = this.email
    const visibles: mail.state.MailWriteVisibles = Object.create(null)
    const set = function(users: any, type: string) {
      if (users && users.length > 0) {
        const list: any[] = ((email as any)[type] = [])
        users.forEach((user: any) => {
          list.push({
            text: user.name,
            value: user.email,
            comCode: user.comCode,
            deptCode: user.deptCode,
            deptName: user.displayDeptName,
            personCode: user.personCode,
          })
        })
        ;(visibles as any)[type] = true
      }
    }
    set(userList, this.type)
    orgmapStorage.set(userInfo)
    this.showMove = false
  }
}
